import { Chip, Stack } from '@mui/material';
import { border, text } from '../../theme/colors';

/**
 * What the realtor says the property has, in their own words. These are claims
 * by the agent, not Eqaya findings — which is why they sit well below the
 * verification panel and carry no tick.
 */
export default function FeatureChips({ features = [] }) {
  const list = (Array.isArray(features) ? features : []).filter((f) => typeof f === 'string' && f.trim());
  if (list.length === 0) return null;

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {list.map((f) => (
        <Chip
          key={f}
          label={f}
          variant="outlined"
          size="small"
          sx={{ borderColor: border.light, color: text.primary, fontWeight: 500 }}
        />
      ))}
    </Stack>
  );
}
